import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import {
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { submitContactUsForm } from "@solveindustrial/Services/EmailService";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type CustomSubmitContactUsFormApiParameter = SubmitContactUsFormApiParameter & {
    company?: string;
    companyType?: string;
    jobTitle?: string;
};

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, CustomSubmitContactUsFormApiParameter>;

export const CustomPopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter.company = state.fieldValues["company"];
    props.apiParameter.jobTitle = state.fieldValues["jobTitle"];
    props.apiParameter.companyType = state.fieldValues["companyType"];
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = {} as never;
        await submitContactUsForm(props.apiParameter);
    } catch (error) {
        logger.warn(`Failed to send custom contact us form: ${error}`);
        props.apiResult = { error } as never;
    }
};

export const chain = [PopulateApiParameter, CustomPopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
